module.exports = __webpack_public_path__ + "img/c.798b878b.png";